import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { switchMap } from 'rxjs/operators';

export interface SubscriptionPlanDTO {
  id: number;
  displayName: string;
  maxUsers: number | null;
  price?: number;
  activationDate?: string;
  expirationDate?: string;
}

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlanService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getSubscriptionPlans(active: boolean = true): Observable<SubscriptionPlanDTO[]> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<SubscriptionPlanDTO[]>(`${environment.apiUrl}/condominium/subscription-plan`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            active: active.toString()
          }
        });
      })
    );
  }
}
